import { Info } from 'lucide-react'

/**
 * QuestionnaireMetadataForm Component
 * Form for questionnaire metadata (version, changelog)
 */
function QuestionnaireMetadataForm({ questionnaire, metadata, onQuestionnaireChange, onMetadataChange }) {
  
  const handleQuestionnaireChange = (field, value) => {
    onQuestionnaireChange({ ...questionnaire, [field]: value })
  }

  const handleMetadataChange = (field, value) => {
    onMetadataChange({ ...metadata, [field]: value })
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Informations du questionnaire
        </h3>

        {/* Questionnaire Title */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Titre du questionnaire *
          </label>
          <input
            type="text"
            value={questionnaire.title}
            onChange={(e) => handleQuestionnaireChange('title', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            placeholder="ex: Questionnaire d'auto-évaluation CEDEC"
            required
          />
        </div>

        {/* Questionnaire Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description *
          </label>
          <textarea
            value={questionnaire.description}
            onChange={(e) => handleQuestionnaireChange('description', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            rows="3"
            placeholder="Description générale du questionnaire..."
            required
          />
        </div>
      </div>

      <div className="border-t border-gray-200 pt-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Métadonnées de la version
        </h3>

        {/* Version Number - Auto-generated */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Numéro de version
          </label>
          <div className="bg-gray-50 px-3 py-2 border border-gray-300 rounded-md">
            <span className="text-sm text-gray-600 italic">
              Auto-généré lors de la création (Format: YYYY.MM.DD.HHMM)
            </span>
          </div>
          <div className="mt-2 bg-blue-50 border border-blue-200 rounded-md p-3">
            <div className="flex items-start space-x-2">
              <Info className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-blue-800">
                <p className="font-medium mb-1">✨ Versioning automatique basé sur l'horodatage</p>
                <p className="text-xs">
                  Le numéro de version est généré automatiquement au format <strong>YYYY.MM.DD.HHMM</strong> 
                  (ex: 2025.10.14.1430) pour garantir l'unicité et la traçabilité temporelle.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Changelog */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notes de version (Changelog) *
          </label>
          <textarea
            value={metadata.changelog}
            onChange={(e) => handleMetadataChange('changelog', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            rows="5"
            placeholder="Décrivez les changements apportés dans cette version...&#10;&#10;Exemple:&#10;- Ajout de 3 nouvelles questions dans le thème Stratégie&#10;- Modification de la pondération des questions financières&#10;- Correction de typos dans les descriptions"
            required
          />
          <p className="mt-1 text-xs text-gray-500">
            Décrivez en détail les modifications apportées par rapport à la version précédente
          </p>
        </div>
      </div>
    </div>
  )
}

export default QuestionnaireMetadataForm